/* global $ */

const $payment = $('.js-payment');
const $banks = $('.js-payment-banks');

const payment = {
  initialize() {
    if ($payment.length) {
      this.createListeners();
      this.checkBanksList();
    }
  },

  createListeners() {
    $payment.on('change', '.js-payment-input', () => {
      this.checkBanksList();
    });
  },

  checkBanksList() {
    const $checked = $('.js-payment-input:checked');

    $banks.hide();

    if (typeof $checked.data('toggle') !== 'undefined') {
      const $target = $($checked.data('toggle'));
      $target.show();
    }
  },
};

export default payment;
